/**
 * Self-contained helpers for SentenceTrends (no PropertyUtil).
 */

export function infinityCheck(num, special) {
  if (special && num === -100) return 0;
  if (num === Infinity || Number.isNaN(num) || num === -0) {
    return 0;
  }
  const n = +num;
  if (n > 100) return 100;
  return +n;
}

export function calculateDiff(curr, prev) {
  if (curr === "0" && prev === "0") {
    return "0";
  }
  if (curr === "0") {
    return -100;
  }
  if (prev === "0") {
    return 100;
  }
  const c = Math.round(+curr);
  const p = Math.round(+prev);
  return infinityCheck(Math.round(((c - p) / Math.abs(p)) * 100));
}

export function endsWithS(name, caps, special, hasS) {
  if (hasS) return "";
  if (special && String(special).slice(-1).toLowerCase() === "s") {
    return "'";
  }
  if (name && String(name).slice(-1).toLowerCase() === "s") {
    return "'";
  }
  return caps ? "'S" : "'s";
}

export function splitAreas(area) {
  if (!area) return [];
  let areaSplit = String(area)
    .split(" & ")
    .join("/")
    .split(", ")
    .join("/")
    .split(",")
    .join("/")
    .split(" / ")
    .join("/")
    .split("/");
  if (areaSplit[areaSplit.length - 1] === "") {
    areaSplit = areaSplit.slice(0, -1);
  }
  return areaSplit;
}

export function slashSeparatedArea(area, noSpace) {
  const splitArea = splitAreas(area);
  const areaLength = splitArea.length;
  if (noSpace) {
    if (areaLength === 1) return area;
    if (areaLength === 2) return `${splitArea[0]}/${splitArea[1]}`;
    if (areaLength === 3)
      return `${splitArea[0]}/${splitArea[1]}/${splitArea[2]}`;
    if (areaLength === 4)
      return `${splitArea[0]}/${splitArea[1]}/${splitArea[2]}/${splitArea[3]}`;
    return area;
  }
  if (areaLength === 1) return area;
  if (areaLength === 2) return `${splitArea[0]} / ${splitArea[1]}`;
  if (areaLength === 3)
    return `${splitArea[0]} / ${splitArea[1]} / ${splitArea[2]}`;
  if (areaLength === 4)
    return `${splitArea[0]} / ${splitArea[1]} / ${splitArea[2]} / ${splitArea[3]}`;
  return area;
}

/**
 * Low / Balanced / High — equivalent to PropertyUtil.homesNumber(background=true).
 * Listings are compared to annual sales pace: ratio = actives / avgHomesSoldLast12Months.
 * Same cutoffs as listing counts vs max(4×sales, 0.1) and max(6×sales, 4.1).
 */
export function inventoryTierFromSupply(homesForSale, avgHomesSoldLast12Months) {
  const sold = Number(avgHomesSoldLast12Months);
  const scale = sold === 0 ? 1 : sold;
  const h = Number(homesForSale);
  const ratio = h / scale;
  const lowMaxRatio = Math.max(4, 0.1 / scale);
  const balancedMaxRatio = Math.max(6, 4.1 / scale);
  if (ratio < lowMaxRatio) return "Low";
  if (ratio <= balancedMaxRatio) return "Balanced";
  return "High";
}

export function toThousandthsSalePrice(num) {
  const rounded = Math.round(Number(num) / 1000) * 1000;
  return rounded.toLocaleString();
}
